import {
  Box,
  Flex,
  PaginationProvider,
  SortProvider,
  SearchProvider,
  ITableFilter,
  ModalProvider,
  FormProvider,
} from 'dash-ui';

import OrganizationUsersTableHeader from './components/OrganizationUsersTableHeader/OrganizationUsersTableHeader';
import OrganizationUsersTable from './components/OrganizationUsersTable/OrganizationUsersTable';
import SaveOrganizationUsersModal from './components/SaveOrganizationUsersModal/SaveOrganizationUsersModal';
import SendRegistrationLinkToUserModal from './components/SendRegistrationLinkToUserModal/SendRegistrationLinkToUserModal';
import SetOrganizationUserStatusModal from './components/SetOrganizationUserStatsModal/SetOrganizationUserStatusModal';
import { FormFieldsList } from './components/SaveOrganizationUsersModal/constants/constants';

function OrganizationUsers({ filter }: { filter: ITableFilter }) {
  return (
    <Box>
      <PaginationProvider>
        <SortProvider>
          <SearchProvider>
            <ModalProvider>
              <Flex flexDirection="column" flex={1} w="100%">
                <div style={{ width: "100%", overflowX: "auto" }}>
                  <OrganizationUsersTableHeader />
                  <OrganizationUsersTable filter={filter} />
                </div>
                <FormProvider fieldsList={FormFieldsList}>
                  <SaveOrganizationUsersModal
                    organizationId={filter.organizationId || ''}
                  />
                </FormProvider>
                <SendRegistrationLinkToUserModal />
                <SetOrganizationUserStatusModal />
              </Flex>
            </ModalProvider>
          </SearchProvider>
        </SortProvider>
      </PaginationProvider>
    </Box>
  );
}

export default OrganizationUsers;
